module.exports = __webpack_public_path__ + "static/media/avatar_50.3c56419e.svg";